import { media, spacing } from '@lamimed/pantheon';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-top: 30rem;
  padding-bottom: ${spacing.medium};

  ${media.greaterThan('tablet')`
    padding-top: 0;
    padding-bottom: 0;
  `};
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    margin-bottom: ${spacing.large};
  }
`;
